import { render, staticRenderFns } from "./sales_budget.vue?vue&type=template&id=ade54ed8&scoped=true"
import script from "./sales_budget.vue?vue&type=script&lang=js"
export * from "./sales_budget.vue?vue&type=script&lang=js"
import style0 from "./sales_budget.vue?vue&type=style&index=0&id=ade54ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade54ed8",
  null
  
)

export default component.exports